module.exports = __webpack_public_path__ + "fundacjajst-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundacjajst-logo.png
// module id = 1632
// module chunks = 0